/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/util/identity.js
// module id = 200
// module chunks = 0